<template>
  <SfTableHeader
    v-for="(header, headerIndex) in headers"
    :key="headerId(header)"
    :header="header"
    :header-index="headerIndex"
    :hidden="hidden"
    :sort-direction="sortDirection"
    :sort-by="sortBy"
    :variant="variant"
    class="sf-pointer"
    @header-click="headerClick"
  >
    <template #header="{ headerLabel }">
      <slot
        name="header"
        :header="header"
        :header-index="headerIndex"
        :header-label="headerLabel"
      ></slot>
    </template>
  </SfTableHeader>
</template>

<script setup lang="ts" generic="HD extends BaseHeader">
import type { BaseHeader } from './types'

import SfTableHeader from './sf-table-header.vue'
import type { TableSortDirections, TableVariants } from './constants'
import { tableSortDirections, tableVariants } from './constants'

interface Props {
  headers: HD[]
  hidden?: boolean
  sortDirection?: TableSortDirections
  sortBy?: HD | ''
  variant?: TableVariants
}

const {
  headers,
  sortDirection = tableSortDirections.ASC,
  sortBy,
  variant = tableVariants.DEFAULT,
} = defineProps<Props>()

const emit =
  defineEmits<{
    headerClick: [header: string]
  }>()

const headerClick = (header: string) => {
  emit('headerClick', header)
}

const headerId = (header: HD): string => {
  return typeof header === 'string' ? header : header.id
}
</script>
